import { useRef } from 'react';

/**
 * Remonta el contenido en cada cambio de tab para que entre desde el lado de la
 * tab elegida (derecha si avanza, izquierda si regresa).
 */
export const CourseTabPanel = ({ tabId, tabs, children }) => {
    const prevTabRef = useRef(tabId);
    const directionRef = useRef('initial');

    if (prevTabRef.current !== tabId) {
        const prevIndex = tabs.findIndex((tab) => tab.id === prevTabRef.current);
        const nextIndex = tabs.findIndex((tab) => tab.id === tabId);
        directionRef.current = nextIndex >= prevIndex ? 'forward' : 'backward';
        prevTabRef.current = tabId;
    }

    return (
        <div
            key={tabId}
            className="course-tab-panel"
            data-direction={directionRef.current}
            role="tabpanel"
        >
            {children}
        </div>
    );
};
